module.exports = __webpack_public_path__ + "img/float_btn_unfold.e7590804.png";